import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import First from '../menforms/First'
import Mayor from '../../menhome/Mayor'
import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Forms || State of GTS";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Home"
            title="Forms"
            subtitledown="Forms"
           />
            <First/>
            {/* <Mayor/> */}
            <Second/>
        </div>
    </>
  )
}

export default Main